import produce from "immer"
import { PathItemFragment, PathItemFragmentDoc } from "@pathwright/graphql-client/src/generated"
import { getApolloClient } from "../pathwright/PathwrightClient"

export const updateCachedPathItemBlocks = (
  item: PathItemFragment,
  blocks: PathItemFragment["blocks"],
  content_id = 0
) => {
  const client = getApolloClient({ schoolId: window.school?.id })

  const fragment = {
    fragment: PathItemFragmentDoc,
    fragmentName: "PathItem",
    id: `PathItem:${item.id}`
  }

  const fragmentData = client.readFragment(fragment)
  const nextFragmentData = produce(fragmentData, (draft: PathItemFragment) => {
    if (!draft.blocks) {
      draft.blocks = {
        content_last_modified: null,
        last_published: null
      }
    }

    if (blocks?.content_last_modified) {
      draft.blocks.content_last_modified = blocks.content_last_modified
    }
    if (blocks?.last_published) {
      draft.blocks.last_published = blocks.last_published
    }

    if (content_id) {
      draft.content_id = content_id
    }
  })
  client.writeFragment({
    ...fragment,
    data: nextFragmentData
  })
}

export const getDocumentPublishMeta = (
  lastPublishedDateTime?: string,
  lastModifiedDateTime?: string
) => {
  const lastPublished = lastPublishedDateTime
    ? new Date(lastPublishedDateTime).toISOString()
    : null
  const contentLastModified = lastModifiedDateTime
    ? new Date(lastModifiedDateTime).toISOString()
    : lastPublished
    ? lastPublished
    : null

  const isPublished =
    lastPublished && lastPublished > (contentLastModified || 0)

  return {
    lastPublished,
    contentLastModified,
    isPublished
  }
}

// If resource and cohort ids are provided or in context,
// we return the full version of the Blocks Step context key (/resource/cohort/step)
// otherwise we simply provide the legacy step id version
export const getStepContextKey = (
  step_id: number,
  resource_id = null,
  cohort_id = null
) => {
  const storeResource = window?.App?.getStore("resource")?.getState()?.resource
  const storeCohort = window?.App?.getStore("resource")?.getState()?.offering

  const resourceId = resource_id || storeResource?.id
  const cohortId = cohort_id || storeCohort?.id

  if (!resourceId || !cohortId) return `/${step_id}`

  return `/${resourceId}/${cohortId}/${step_id}`
}

export const getReportingContextKey = (resourceId: number) =>
  `reporting-${resourceId}`
